import React from 'react';
import { ButtonToolbar, Button, Panel, Tab, Alert, Nav, NavItem, Row, Col } from 'react-bootstrap';
import moment from 'moment-business-days';
import { addContract, updateContract } from 'utils/ContractsAPIUtils';
import Store from 'stores/ContractsStore';
import ContractPropsEditor from './ContractPropsEditor';
import TariffRatesList from './TariffRatesList';
import AccessorialRatesList from './AccessorialRatesList';
import ContractValidator from './ContractValidator';
export default class ContractsEditorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contract: Store.getContractById(this.props.match.params.id) || this.newContract(),
        };
        this.onChange = () => this.onStoreChange();
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    onStoreChange() {
        if (Store.getStatus() === 'success') {
            const propsContract = Store.getContractById(this.props.match.params.id);
            const storeContract = Store.getContract();
            if (storeContract._id) {
                this.setState({ contract: storeContract, hasBeenEdited: false });
            }
            else {
                this.setState({ contract: propsContract, hasBeenEdited: false });
            }
        }
        else {
            this.setState({ hasBeenEdited: true });
        }
    }
    save() {
        return () => {
            if (this.state.contract) {
                Store.reset();
                addContract(this.state.contract);
            }
            this.setState({ hasBeenEdited: false });
        };
    }
    update() {
        return () => {
            if (this.state.contract) {
                Store.reset();
                updateContract(this.state.contract);
            }
            this.setState({ hasBeenEdited: false });
        };
    }
    handlePropertiesChange() {
        return (key, value) => {
            const contract = this.state.contract;
            contract[key] = value;
            this.setState({ hasBeenEdited: true, contract: contract });
        };
    }
    isValid(value) {
        return value && value.length > 0;
    }
    validateDate(startDate, endDate) {
        const start = moment(startDate);
        const end = moment(endDate);
        if (start.isAfter(end)) {
            return false;
        }
        else if (end.isBefore(moment())) {
            return false;
        }
        return true;
    }
    setStatus() {
        return () => {
            const result = ContractValidator(this.state.contract);
            let status = this.state.contract.status;
            if (result.value) {
                if (status !== 'expired') {
                    status = (status === 'active') ? 'hold' : 'active';
                }
            }
            this.state.contract.status = status;
            this.state.alert = result.info;
            this.setState();
            this.update();
        };
    }
    newContract() {
        return {
            contract_name: '',
            parties: 'shipper',
            start_date: new Date(),
            expiration_date: new Date(),
            status: 'draft',
            user: '',
            user_name: '',
            term: 0,
            tariff_rates: [],
            accessorial_rates: [],
        };
    }
    render() {
        const valid = this.isValid(this.state.contract.contract_name) && this.isValid(this.state.contract.user) && this.validateDate(this.state.contract.start_date, this.state.contract.expiration_date);
        const newContractMode = (!this.state.contract || !this.state.contract._id);
        const disableSaveButton = (!this.state.hasBeenEdited && !newContractMode) || !valid;
        let alert = '';
        if (this.state.alert) {
            alert = (React.createElement(Alert, { bsStyle: "danger" },
                this.state.alert,
                "\u00A0\u00A0",
                React.createElement(Button, { onClick: () => this.setState({ alert: '' }) }, "Hide Alert")));
        }
        return (React.createElement("div", null,
            React.createElement("div", null,
                alert,
                React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: "1" },
                    React.createElement(Row, { className: "clearfix" },
                        React.createElement(Col, { sm: 2 },
                            React.createElement(Nav, { bsStyle: "pills", stacked: true },
                                React.createElement(NavItem, { eventKey: "1" }, "Properties"),
                                React.createElement(NavItem, { eventKey: "2", disabled: newContractMode }, "TariffRates"),
                                React.createElement(NavItem, { eventKey: "3", disabled: newContractMode }, "AccessorialRates"))),
                        React.createElement(Col, { sm: 10 },
                            React.createElement(Tab.Content, { animation: true },
                                React.createElement(Tab.Pane, { eventKey: "1" },
                                    React.createElement(Panel, null,
                                        React.createElement(ContractPropsEditor, { contract: this.state.contract, onChange: this.handlePropertiesChange() }))),
                                React.createElement(Tab.Pane, { eventKey: "2" },
                                    React.createElement(Panel, { className: "table-responsive" },
                                        React.createElement(TariffRatesList, { contract: this.state.contract }))),
                                React.createElement(Tab.Pane, { eventKey: "3" },
                                    React.createElement(Panel, { className: "table-responsive" },
                                        React.createElement(AccessorialRatesList, { contract: this.state.contract })))))))),
            React.createElement("div", { style: { float: 'right' } },
                React.createElement(ButtonToolbar, null,
                    React.createElement(Button, { bsStyle: "primary", disabled: (this.state.contract.status === 'expired') || (newContractMode), onClick: this.setStatus() }, (this.state.contract.status === 'active') ? 'Hold' : 'Active'),
                    React.createElement(Button, { bsStyle: "primary", disabled: disableSaveButton, onClick: (newContractMode) ? this.save() : this.update() }, (newContractMode) ? 'Save' : 'Save Changes')))));
    }
}
